import { Link } from "react-router-dom";
import { ArrowLeft, Construction } from "lucide-react";
import { TerminalShell } from "@/components/TerminalShell";

export const ComingSoonPage = ({ title, description, stage }) => (
  <TerminalShell>
    <div data-testid="coming-soon-page" className="p-6 sm:p-10">
      <div className="max-w-2xl space-y-6 rounded-md border border-[#141A26] bg-[#0A0E16] p-8 sm:p-10">
        <span className="inline-flex items-center gap-2 rounded-md border border-[#2563EB]/40 bg-[#2563EB]/10 px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-[#5B9CFF]">
          <Construction className="h-3.5 w-3.5" /> Em breve
        </span>
        <h1 className="font-heading text-4xl font-light tracking-tight text-white sm:text-5xl">{title}</h1>
        <p className="text-sm leading-relaxed text-[#8A97AD]">{description}</p>
        {stage ? <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#5C6B82]">{stage}</p> : null}
        <Link
          to="/terminal"
          data-testid="back-to-terminal"
          className="inline-flex items-center gap-2 rounded-md border border-[#1D2637] px-5 py-3 text-sm text-[#C7D0DE] transition-colors hover:border-[#2563EB]/60 hover:text-white"
        >
          <ArrowLeft className="h-4 w-4" /> Voltar ao terminal
        </Link>
      </div>
    </div>
  </TerminalShell>
);
